(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller.overview
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
   [frontend.ui.component.lp-portal.report.overview.big-figures.controller :as big-figures]
   [frontend.ui.component.chart.utils :as chart-utils]))

(defn- portfolio-at-market-value
  [{:keys [labels portfolio-at-market-value]}]
  (map vector labels portfolio-at-market-value))

(defn- gav-breakdown
  [{:keys [labels ifrs]}]
  (map vector labels ifrs))

(defn overview
  [{:keys [report-data] :as props}]
  {:overview-figures         (report-ctl/with-footnote
                              props
                              :overview-figures-footnotes
                              (big-figures/stockholm-living-summary-figures report-data))
   :recent-development-text  (report-ctl/rich-content props :recent-development-text)
   :highlights               (report-ctl/with-footnote
                              props
                              :highlight-footnotes
                              (get-in report-data [:fund-figures]))
   :portfolio-at-market-value (report-ctl/with-footnote
                               props
                               :portfolio-at-market-value-footnotes
                               (donut-chart/donut-chart-config
                                (->> (portfolio-at-market-value
                                      (:chart-data-market-value
                                       report-data))
                                     (remove (fn [[_l v]]
                                               (zero? v))))
                                {:data-label-formatter
                                 chart-utils/pie-float-label-formatter-no-division}))
   :gav-breakdown            (report-ctl/with-footnote
                              props
                              :gav-breakdown-footnotes
                              (donut-chart/donut-chart-config
                               (->> (gav-breakdown
                                     (:chart-data-gav-breakdown
                                      report-data))
                                    (remove (fn [[_l v]]
                                              (zero? v))))
                               {:data-label-formatter
                                chart-utils/pie-float-label-formatter-divide-m}))})
